import * as React from "react";

const IconComment: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="currentColor"><path fill="currentColor" d="M3,9.75 L3.75,9.75 L3.75,10.5 L3.75,11.0976562 L3.75,12 L4.5,11.5007815 L7.125,9.75 L11.25,9.75 L12,9.75 L12,9 L12,0.75 L12,0 L11.25,0 L0.75,0 L0,0 L0,0.75 L0,9 L0,9.75 L0.75,9.75 L3,9.75 Z M0.75,9 L0.75,0.75 L11.25,0.75 L11.25,9 L7.125,9 L6.89765596,9 L6.70781207,9.12656236 L4.5,10.5984378 L4.5,9.75 L4.5,9 L3.75,9 L0.75,9 Z"  transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconComment);
